/**
 * @file: 选择器选择对象存储
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import Utils from '../../../utils/util';

// 已选择的cubeId
let db: Set<CubeId> = new Set();

// 按cube类型存储
let cubeTypeDB: Map<CubeType, Set<CubeId>> = new Map();

// 所有选中的cube外边界坐标
let wrapRect: LogicCoordinate = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};

function __add__(cubeId: CubeId): void {
    let cube: CubeNode = CubeTree.findByCubeId(cubeId);
    let cubeType: CubeType = CubeTree.getCubeType(cube);

    if (!cubeTypeDB.has(cubeType)) {
        cubeTypeDB.set(cubeType, new Set());
    }

    cubeTypeDB.get(cubeType).add(cubeId);
    db.add(cubeId);
}

function __size__(): number {
    return db.size;
}

// 是否存在
function __has__(cubeId: CubeId): boolean {
    return db.has(cubeId);
}

// 清空
function __clear__(): void {
    db.clear();
    cubeTypeDB.clear();
}

function __getAll__(): Array<CubeId> {
    return Array.from(db);
}

function __delete__(cubeId: CubeId): void {
    if (!__has__(cubeId)) {
        return;
    }
    let cube: CubeNode = CubeTree.findByCubeId(cubeId);
    let cubeType: CubeType = CubeTree.getCubeType(cube);
    let typeList: Set<CubeId> = cubeTypeDB.get(cubeType);

    if (typeList) {
        typeList.delete(cubeId);
    }

    if (!typeList.size) {
        cubeTypeDB.delete(cubeType);
    }
    db.delete(cubeId);
}

function __updateWrapRect__(rect: LogicCoordinate): void {
    wrapRect.width = rect.width;
    wrapRect.height = rect.height;
    wrapRect.left = rect.left;
    wrapRect.top = rect.top;
}

function __getWrapRect__(): LogicCoordinate {
    return {
        width: wrapRect.width,
        height: wrapRect.height,
        left: wrapRect.left,
        top: wrapRect.top
    }
}

function __resetWrapRect__(): void {
    wrapRect.width = 0;
    wrapRect.height = 0;
    wrapRect.left = 0;
    wrapRect.top = 0;
}

function __getByType__(type: CubeType): Array<string> {
    return cubeTypeDB.has(type) ? Array.from(cubeTypeDB.get(type)) : [];
}

function __allType__(): Array<CubeType> {
    return Array.from(cubeTypeDB.keys());
}

export {
    __add__,
    __size__,
    __has__,
    __clear__,
    __getAll__,
    __delete__,
    __getWrapRect__,
    __resetWrapRect__,
    __updateWrapRect__,
    __getByType__,
    __allType__
};
